export interface IPataviumPagedResponse<T> {
    payload: T[];
    total: number;
    typeOfEntity: string;
}

export interface IPataviumResponseFirstItem<T> {
    item: T;
}

export class PataviumPagedResponse<T, U> implements IPataviumPagedResponse<U> {
    payload: U[] = [];
    total = 0;
    typeOfEntity: string = null;
    constructor(response: IPataviumPagedResponse<T>, cls: { new (t: T): U }) {
        if (response != null && cls != null) {
            this.payload = response.payload.map(el => new cls(el));
            this.total = response.total;
            this.typeOfEntity = cls.name;
            console.log('PataviumResponse<T, U>', response, this);
        }
    }
}

export class PataviumPagedResponseFirstItem<T> implements IPataviumResponseFirstItem<T> {
    item: T = null;
    constructor(response: IPataviumPagedResponse<T>, cls?: { new (t: T): T }) {
        if (response && response.payload.length > 0) {
            if (cls) {
                this.item = new cls(response.payload[0]);
            } else {
                this.item = response.payload[0];
            }
        }
    }
}

export interface IPataviumResponse<T> {
    payload: T;
    typeOfEntity: string;
}


export class PataviumResponse<T, U> implements IPataviumResponse<U> {
    payload: U = null;
    typeOfEntity: string = null;
    constructor(response: IPataviumResponse<T>, cls: { new (t: T): U }) {
        if (response != null && cls != null) {
            this.payload = new cls(response.payload);
            this.typeOfEntity = cls.name;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/response.class.ts